import MagicForm from '../../../../../../Components/Form/MagicForm';
import React from 'react';
import {
	buildInsuranceCompaniesCheckboxScheme,
	InsuranceCompanyCheckboxItem,
} from '../../../../Helpers/InsuranceCompanies/buildInsuranceCompaniesCheckboxScheme';

interface Props {
	items: InsuranceCompanyCheckboxItem[];
	selectedItems: string[];
	onSubmit: (codes: Record<string, boolean>) => void;
}

const ManagerInsuranceCompaniesCheckboxes = ({
	items,
	selectedItems,
	onSubmit,
}: Props) => {
	return (
		<MagicForm
			formScheme={buildInsuranceCompaniesCheckboxScheme(items, selectedItems)}
			onSubmit={onSubmit}
		/>
	);
};

export default ManagerInsuranceCompaniesCheckboxes;
